module.exports = require('./bundle-url').getBundleURL() + require('./relative-path')("2h6VV", "42fVg")